import createRoute                from '@widesk-ui/tools/createRoute';
import AccountSubscriptionModel  from '@models/account/AccountSubscriptionModel';

export default createRoute.dashboard('/account_subscriptions', 'account', 'AccountSubscriptionDashboard', AccountSubscriptionModel.localize());
